export const modalText = {
  modalTitle: 'About journey',
  descriptionInputPlaceholder: 'What are your goals?',
  charactersPlaceholder: ' (140 characters)',
  workflowNameLabel: 'Journey name',
  descriptionLabel: 'Description',
  updateButtonLabel: 'Update',
  workflowIdLabel: 'Journey ID',
  nodesUsedLabel: 'Nodes used',
  createdOnLabel: 'Created on',
  lastModifiedLabel: 'Last modified on',
  tilesUsedLabel: 'Tiles in journey',
  lastModified: 'Last modified',
  createdLabel: 'Created',
  copiedToLabel: 'Copied to',
  copiedFromLabel: 'Copied from',
};

export const WORKFLOW_DETAILS_CREATED_ON_TEXT = 'workflow-details-created-on';
export const WORKFLOW_DETAILS_UPDATED_AT_TEXT = 'workflow-details-updated-at';
export const WORKFLOW_DETAILS_DESCRIPTION = 'workflow-details-description';
export const WORKFLOW_DETAILS_NAME = 'workflow-details-name';
export const WORKFLOW_DETAILS_SUBMIT = 'workflow-details-submit';
export const WORKFLOW_DETAILS_CLONE = 'workflow-details-clone';
